// extracted by mini-css-extract-plugin
module.exports = {"Logo":"DataHighlights_Logo__uzrcj"};